// iPhone → Apple Watch prayer times sync
//
// Usage from anywhere in the app after prayer times are fetched:
//   import { syncPrayerTimesFromAladhan } from "./watchSync";
//   syncPrayerTimesFromAladhan({ date: "2026-04-23", timings: data.timings });

function isNative() {
  return !!window.Capacitor?.isNativePlatform?.();
}

function getPlugin() {
  return window.Capacitor?.Plugins?.SiratWatch;
}

function hhmmToEpochSeconds(dateYYYYMMDD, hhmm) {
  if (!dateYYYYMMDD || !hhmm) return null;
  const [y, m, d] = dateYYYYMMDD.split("-").map(Number);
  const cleaned = String(hhmm).replace(/\s*\(.*\)$/, "").trim();
  const [h, min] = cleaned.split(":").map(Number);
  if ([y, m, d, h, min].some((n) => Number.isNaN(n))) return null;
  const dt = new Date(y, m - 1, d, h, min, 0, 0);
  return Math.floor(dt.getTime() / 1000);
}

export async function isWatchAvailable() {
  if (!isNative()) return false;
  const plugin = getPlugin();
  if (!plugin) return false;
  try {
    const info = await plugin.isAvailable();
    return !!info?.available;
  } catch {
    return false;
  }
}

export async function sendPrayerTimesToWatch({ date, times }) {
  if (!isNative()) return { sent: false, reason: "not-native" };
  const plugin = getPlugin();
  if (!plugin) return { sent: false, reason: "plugin-missing" };
  try {
    return await plugin.sendPrayerTimes({ date, times });
  } catch (e) {
    return { sent: false, reason: String(e) };
  }
}

// High-level helper for Aladhan-formatted payloads.
// Pass timings with "HH:mm" strings (optionally with " (TZ)" suffix).
export async function syncPrayerTimesFromAladhan({ date, timings }) {
  if (!timings || !date) return { sent: false, reason: "missing-args" };
  const times = {
    fajr: hhmmToEpochSeconds(date, timings.Fajr),
    sunrise: hhmmToEpochSeconds(date, timings.Sunrise),
    dhuhr: hhmmToEpochSeconds(date, timings.Dhuhr),
    asr: hhmmToEpochSeconds(date, timings.Asr),
    maghrib: hhmmToEpochSeconds(date, timings.Maghrib),
    isha: hhmmToEpochSeconds(date, timings.Isha)
  };
  if (Object.values(times).some((v) => v == null)) {
    return { sent: false, reason: "bad-timings" };
  }
  return sendPrayerTimesToWatch({ date, times });
}
